import _ from 'lodash'
import store from './store/'

// define available routes fot ClientCollaborator
const accesibleRoutesForClientCollaborator = ['url-planner', 'content-briefs', 'calendar', 'campaign-guidelines', 'user-account', 'user']

const availableClientRoutes = ['/authorization', '/project-membership', '/reports', '/link-building', '/dashboard', '/url-planner', '/calendar', '/content-briefs', '/campaign-guidelines', '/user-account', '/integrations', '/user', '/setup-wizard']

// const adminOnlyRoutes = ['/data/link']

export function accessToAgentRoutes (currentUser, accessRoutes, route) {
  const skipRouteNames = ['pricing_table', 'agency_dashboard', 'billing', 'edit', 'upload', 'review', 'skip_update', 'children', 'UserTab', 'AgencyRolesTab', 'color-testing',
    'ClientRolesTab', 'GeneralInfoTab', 'RankReportTargetingTab', 'MSVTab', 'UrlGeneralInfoTab', 'UrlRankReportTargetingTab', 'AssociatedURLAttributesTab']
  return currentUser &&
    !accessRoutes.includes('empty') &&
    !availableClientRoutes.some(clientRoute => route.path.includes(clientRoute)) &&
    !skipRouteNames.includes(route.name) &&
    !accessRoutes.some(i => i.link === '/' + route.name)
}

export function cannotNavigateToRoute (currentUser, routeNavigateTo) {
  return (
    currentUser &&
    currentUser.isClientCollaborator() &&
    !accesibleRoutesForClientCollaborator.some(route => routeNavigateTo.includes(route))
  ) || (
    currentUser &&
    currentUser.isClientContributor() &&
    ['campaign-guidelines', '/strategy/campaign-guidelines', '/strategy/calendar', '/strategy/calendar'].includes(routeNavigateTo)
  )
}

//  check routes forbidden for collaborator
export function cannotNavigateToQueryClientRoute (currentUser, routeNavigateTo, clients) {
  const isRouteForbiddenForSelectedClient = cannotNavigateToRoute(currentUser, routeNavigateTo.path)
  // check if this route has query with attached client_id
  const query = routeNavigateTo.query
  if (!query || _.isEmpty(query)) {
    return isRouteForbiddenForSelectedClient
  }
  let clientId = null
  Object.values(query).forEach(item => {
    if (item.includes('client_id')) {
      const queryValue = JSON.parse(item)
      clientId = queryValue['client_id']
    }
  })
  if (clientId && !clients.length) {
    return false
  }
  if (clientId) {
    const client = clients.find(item => item._id === clientId)
    if (!client) {
      // cannot navigate to unknown client
      return true
    }
    // navigate to route if user is client_collaborator for this found client
    if (client.user_role === 'client_collaborator') {
      return accesibleRoutesForClientCollaborator.some(route => !routeNavigateTo.path.includes(route))
    } else {
      // if user is not client_collaborator - there is no restrictions for open this route even if this route for selectedClient is forbidden
      return false
    }
  }

  return isRouteForbiddenForSelectedClient
}

// If user has no clients, only show the Settings options in sidebar
export function hideMenuItemsIfNoClients (routes) {
  if (store.state.clients.length) {
    return routes
  }
  const settingsRouteIndex = routes.findIndex(route => route.path === '/settings')
  return [routes[settingsRouteIndex]]
}

export function configureLeftMenuItemsByProject (routes) {
  const linkBuildingReportEnabled = store.state.rankZoneCommon.linkBuildingReportEnabled

  return _.cloneDeep(routes).map(item => {
    if (!linkBuildingReportEnabled) {
      if (item.path === '/reports') {
        const deleteIndex = item.children.findIndex(child => child.path === 'link-building')
        item.children.splice(deleteIndex, 1)
      }
    }
    return item
  })
}

export function configureMenuItems (routes, prefix = '') {
  return routes.map(route => {
    let path = route.path.startsWith('/') ? route.path : '/' + route.path
    path = prefix + path
    route.visible = store.state.allowedRoutes.some(allowedRoute => allowedRoute === path)
    if (route.children && route.children.length) {
      route.children = configureMenuItems(route.children, path)
      // Handle instance where parent visibility is false but child visibility is true
      if (route.children.some(child => child.visible)) {
        route.visible = true
      }
    }
    return route
  })
}

// hide routes and navbar items forbidden for collaborator
export function configureLeftMenuItemsByUserRole (currentUser, routes) {
  routes = hideMenuItemsIfNoClients(routes)
  routes = configureLeftMenuItemsByProject(routes)
  if (currentUser.isClientCollaborator()) {
    return _.cloneDeep(routes).map(item => {
      if ((
        !item.isHiddenInNavbar &&
        item.path.startsWith('/') &&
        !item.showChildrenInNavbar
      ) || (
        item.showChildrenInNavbar &&
        !item.path.startsWith('/')
      )) {
        if (cannotNavigateToRoute(currentUser, item.path)) {
          Object.assign(
            item,
            item.path.startsWith('/') ? { isHiddenInNavbar: true } : { showChildrenInNavbar: false }
          )
        }
      } else if (item.children && item.children.length) {
        item.children = configureLeftMenuItemsByUserRole(currentUser, item.children)
      }
      if (
        !item.isHiddenInNavbar &&
        item.showChildrenInNavbar &&
        item.children &&
        !item.children.some(i => i.showChildrenInNavbar)
      ) {
        item.isHiddenInNavbar = true
      }
      if (['campaign-guidelines', 'calendar'].includes(item.name) && currentUser.isClientContributor()) {
        item.showChildrenInNavbar = false
      }
      return item
    })
  }

  return _.cloneDeep(routes)
}
